import React from "react"

function Profil() {
    return (
        <div className="profil mb5">
            <h2>Profil</h2>
            <p>
                Fort d’une expérience professionnelle de 22 ans en métallurgie, j’ai décidé de faire une reconversion en t’en que développer Web.
                Depuis 2019, à la suite de plusieurs refus de demande de formation via le FONGECIF, j’ai décidé de me former en autodidacte,
                en parallèle de ma vie professionnel et familiale.
                Le développement est devenu une passion. Maintenant, je suis à la recherche d’un poste pour enfin en faire mon métier.
                Je recherche une entreprise pour pouvoir mettre en application mes compétences et continué à évoluer dans le métier.
                Mais aussi à faire des formations pour pouvoir travailler avec d’autres langages ou logiciels pour le besoin sur des projets
                et étendre mes compétences dans le métier.
            </p>
        </div>
    )
}

export default Profil